/**
 * What a Member sees while the account is not set up: choosing a plan and adding
 * websites are Owner and Admin actions, so they wait for one rather than meet a
 * button the server would refuse.
 */
export const WaitingStep = () => (
  <div className="flex max-w-xl flex-col gap-2">
    <h1 className="text-foreground m-0 text-[26px] font-medium leading-[1.15] tracking-[-0.02em]">
      Your account is almost ready
    </h1>
    <p className="supporting m-0 text-lede">
      An account Owner or Admin needs to choose a plan and add the first website. Once they have, you will see the
      dashboard here. You can close this page and come back later.
    </p>
  </div>
);
